const type = 'OPEN_RECHARGE';

const openRecharge = () => ({
  type,
});

export { type };
export default openRecharge;
